import Vue from 'vue';

const cms = new Vue({
    created(){
    },
    methods: {
        forceLanguageUpdate(){
            // this.loadCmsStrings();
        },

        load(){
            this.loadCmsStrings();
            this.loadCmsFiles();
        },

        string(key, loadingDefault){
            if (this.cmsStrings.loading){
                return loadingDefault || '';
            }

            return this.cmsStrings.data[key];
        },

        file(key, loadingDefault){
            if (this.cmsFiles.loading){
                return loadingDefault || '';
            }

            return this.cmsFiles.data[key];
        },

        stringsReady(){
            return !this.cmsStrings.loading;
        },

        filesReady(){
            return !this.cmsFiles.loading;
        },

        loadCmsStrings(){
            this.cmsStrings.loading = true;

            this.$http.get(this.cmsStrings.url)
                .then(resp => {
                    this.cmsStrings.loading = false;
                    this.cmsStrings.data = resp.data;
                }).catch(err => {
                    this.cmsStrings.data = {};
                });
        },

        loadCmsFiles(){
            this.cmsFiles.loading = true;
            this.cmsFiles.data = {};

            this.$http.get(this.cmsFiles.url)
                .then(resp => {
                    this.cmsFiles.loading = false;
                    this.cmsFiles.data = resp.data;
                }).catch(err => {
                    this.cmsFiles.data = {};
                });
        },
    },
    data(){
        return {
            cmsStrings: {
                data: {},
                loading: true,
                url: null
            },
            cmsFiles: {
                data: {},
                loading: true,
                url: null
            },
        }
    }
});

const VueCms = {
    install(Vue, options) {
        Vue.mixin({
            mounted() {

            }
        });

        cms.cmsStrings.url = options.urls.strings;
        cms.cmsFiles.url = options.urls.files;

        Vue.prototype.$cms = cms;

        // cms.load();
    }
};

export default VueCms;